import React from "react";
import "@/App.css";
import "@/styles/tiptap.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import DynamicHome from "@/pages/DynamicHome";
import Services from "@/pages/Services";
import Insights from "@/pages/Insights";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import PublicPage from "@/pages/PublicPage";
import PropertiesList from "@/pages/PropertiesList";
import PropertyDetail from "@/pages/PropertyDetail";
import NewsList from "@/pages/NewsList";
import NewsDetail from "@/pages/NewsDetail";

// Admin imports
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import LeadsManager from "@/pages/admin/LeadsManager";
import PropertiesManager from "@/pages/admin/PropertiesManager";
import MarketBriefsManager from "@/pages/admin/MarketBriefsManager";
import SettingsPage from "@/pages/admin/SettingsPage";
import MediaLibrary from "@/pages/admin/MediaLibrary";
import Pages from "@/pages/admin/Pages";
import ContentManager from "@/pages/admin/ContentManager";
import PageBuilder from "@/pages/admin/PageBuilder";
import NewsManager from "@/pages/admin/NewsManager";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <>
              <Header />
              <DynamicHome />
              <Footer />
            </>
          } />
          <Route path="/services" element={
            <>
              <Header />
              <Services />
              <Footer />
            </>
          } />
          <Route path="/insights" element={
            <>
              <Header />
              <Insights />
              <Footer />
            </>
          } />
          <Route path="/about" element={
            <>
              <Header />
              <About />
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Header />
              <Contact />
              <Footer />
            </>
          } />

          {/* Properties */}
          <Route path="/properties" element={
            <>
              <Header />
              <PropertiesList />
              <Footer />
            </>
          } />
          <Route path="/properties/:slug" element={
            <>
              <Header />
              <PropertyDetail />
              <Footer />
            </>
          } />

          {/* News / Analyses */}
          <Route path="/news" element={
            <>
              <Header />
              <NewsList />
              <Footer />
            </>
          } />
          <Route path="/news/:slug" element={
            <>
              <Header />
              <NewsDetail />
              <Footer />
            </>
          } />
          
          {/* Dynamic Pages */}
          <Route path="/p/:slug" element={<PublicPage />} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="leads" element={<LeadsManager />} />
            <Route path="properties" element={<PropertiesManager />} />
            <Route path="news" element={<NewsManager />} />
            <Route path="insights" element={<MarketBriefsManager />} />
            <Route path="media" element={<MediaLibrary />} />
            <Route path="pages" element={<Pages />} />
            <Route path="content" element={<ContentManager />} />
            <Route path="page-builder/:pageKey" element={<PageBuilder />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Routes>

        <Toaster 
          position="bottom-right"
          toastOptions={{
            style: {
              background: '#111111',
              color: '#F6F2E8',
              border: '1px solid rgba(212, 175, 55, 0.2)',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
